import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PurchaseOrder, Client, UoM, POStatus } from '../../services/purchaseOrderApi';

interface PurchaseOrderState {
  purchaseOrders: PurchaseOrder[];
  loading: boolean;
  error: string | null;
  selectedPurchaseOrder: PurchaseOrder | null;
  total: number;
  page: number;
  limit: number;
  clients: Client[];
  uoms: UoM[];
  poStatuses: POStatus[];
  loadingDropdowns: boolean;
}

const initialState: PurchaseOrderState = {
  purchaseOrders: [],
  loading: false,
  error: null,
  selectedPurchaseOrder: null,
  total: 0,
  page: 1,
  limit: 10,
  clients: [],
  uoms: [],
  poStatuses: [],
  loadingDropdowns: false,
};

const purchaseOrderSlice = createSlice({
  name: 'purchaseOrder',
  initialState,
  reducers: {
    fetchPurchaseOrdersStart: (state, action: PayloadAction<{ page?: number; limit?: number; search?: string }>) => {
      state.loading = true;
      state.error = null;
      if (action.payload.page) state.page = action.payload.page;
      if (action.payload.limit) state.limit = action.payload.limit;
    },
    fetchPurchaseOrdersSuccess: (state, action: PayloadAction<{ data: PurchaseOrder[]; total: number; page: number; limit: number }>) => {
      state.purchaseOrders = action.payload.data;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
      state.loading = false;
    },
    fetchPurchaseOrdersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addPurchaseOrder: (state, action: PayloadAction<Omit<PurchaseOrder, 'id'>>) => {
      // This will be handled by the saga
    },
    updatePurchaseOrder: (state, action: PayloadAction<PurchaseOrder>) => {
      // This will be handled by the saga
    },
    deletePurchaseOrder: (state, action: PayloadAction<string>) => {
      // This will be handled by the saga
    },
    setSelectedPurchaseOrder: (state, action: PayloadAction<PurchaseOrder | null>) => {
      state.selectedPurchaseOrder = action.payload;
    },
    fetchDropdownsStart: (state) => {
      state.loadingDropdowns = true;
    },
    fetchDropdownsSuccess: (state, action: PayloadAction<{ clients: Client[]; uoms: UoM[]; poStatuses: POStatus[] }>) => {
      state.clients = action.payload.clients;
      state.uoms = action.payload.uoms;
      state.poStatuses = action.payload.poStatuses;
      state.loadingDropdowns = false;
    },
    fetchDropdownsFailure: (state, action: PayloadAction<string>) => {
      state.loadingDropdowns = false;
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearPurchaseOrders: (state) => {
      state.purchaseOrders = [];
      state.selectedPurchaseOrder = null;
      state.total = 0;
      state.page = 1;
    },
  },
});

export const {
  fetchPurchaseOrdersStart,
  fetchPurchaseOrdersSuccess,
  fetchPurchaseOrdersFailure,
  addPurchaseOrder,
  updatePurchaseOrder,
  deletePurchaseOrder,
  setSelectedPurchaseOrder,
  fetchDropdownsStart,
  fetchDropdownsSuccess,
  fetchDropdownsFailure,
  clearError,
  clearPurchaseOrders,
} = purchaseOrderSlice.actions;

export default purchaseOrderSlice.reducer; 